import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderElectionGuide from "../../../../src/content/election-guide-sign-up/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderElectionGuide,
  React
};